export const EVENT_EDIT_PROTOCOL_NEC = "protocolNecessity";
export const EVENT_EDIT_TASK_NEC = "taskNecessity";
export const EVENT_EDIT_TASK_TODO = "todo";
export const EVENT_CLICK_OBJECTIVE = "objective";
export const EVENT_CLICK_STATUS = "status";
export const EVENT_CLICK_STATUS_NEW_TAB_ICON = "status_newTabIcon";
export const EVENT_CLICK_DSIGN_INFO_VIEW = "dsgnInfoView";

export const RELATED_IDF_PJT_TEMPLATE_FILE_URL =
  "spreadsheet-template/component-project-detail-related-idf-project.xlsx";
export const PROTOCOL_TEMPLATE_FILE_URL =
  "spreadsheet-template/component-project-detail-protocol.xlsx";
export const TASK_TEMPLATE_FILE_URL =
  "spreadsheet-template/component-project-detail-task.xlsx";
export const TASK_STATUS_TEMPLATE_FILE_URL =
  "spreadsheet-template/component-project-detail-task-status.xlsx";
export const EDI_NOTIFICATOR_TASK_TEMPLATE_FILE_URL =
  "spreadsheet-template/component-project-detail-edi-notificator-task.xlsx";

export const REQUEST_CD_TYPES = {
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
  ROLE_TYPE: "role_type",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);
